export const HABITATIONAL_POLICY_FORM_CANCELLATION_REINSTATEMENT = "/habitational-policy/:customerId/policy-forms-tab/:customerPolicyId/cancellation-or-reinstatement";
